import { render, staticRenderFns } from "./Gearbox.vue?vue&type=template&id=bda31cc4&scoped=true&"
import script from "./Gearbox.vue?vue&type=script&lang=js&"
export * from "./Gearbox.vue?vue&type=script&lang=js&"
import style0 from "./Gearbox.vue?vue&type=style&index=0&id=bda31cc4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda31cc4",
  null
  
)

export default component.exports